import type { RootState } from '@/store';
import type { IResourcesState } from '@/store/types';

export const selectFoldersList = (state: RootState): IResourcesState['foldersList'] => state.resources.foldersList;
export const selectIsPreviewOpen = (state: RootState): IResourcesState['isPreviewOpen'] =>
  state.resources.isPreviewOpen;
export const selectSelectedResourceDetails = (state: RootState): IResourcesState['selectedResourceDetails'] =>
  state.resources.selectedResourceDetails;
export const selectSelectedAttachments = (state: RootState): IResourcesState['selectedAttachments'] =>
  state.resources.selectedAttachments;
export const selectDatabaseFieldTypeDict = (state: RootState): IResourcesState['databaseFieldTypeDict'] =>
  state.resources.databaseFieldTypeDict;
export const selectLatestDatabaseItems = (state: RootState): IResourcesState['latestDatabaseItems'] =>
  state.resources.latestDatabaseItems;
export const selectFavorites = (state: RootState): IResourcesState['favorites'] => state.resources.favorites;
export const selectDatabaseViewQueryParams = (state: RootState): IResourcesState['databaseViewQueryParams'] =>
  state.resources.databaseViewQueryParams;

export const selectPending = (state: RootState): string[] => state.resources.meta.pending;
export const selectPendingAction =
  (actionType: string) =>
  (state: RootState): boolean =>
    state.resources.meta.pending.some(action => action === actionType);
